export default {
    wrongArguments: 3,
    userEmailNotUnique: 301,
    existsUserWithEmail: 302,
    userNpiNotUnique: 303,
    userCreateFailed: 1,
};
